import Widget from "csi/form/Widget";
import xml from "csi/xml";
import Query from "csi/xml/Query";
import declare from "dojo/_base/declare";
import { ATTR_PARENT, C8Node, DUMMY } from "csi/typings";
import _ from "lodash";
import Relationship from "csi/def/Relationship";
import enums from "csi/enums";
import Nodes from "csi/store/Nodes";
import { DEP_PATH } from "csi/constants";

export const FIELD_DOCUMENT_TEMPLATE = "DocumentTemplate";
export const FIELD_OUTPUT_TYPE = "OutputType";
export const EXCEL_FILE_EXTENSION = ".xlsx";
const ATTR_PRIMARY_SUBTYPE = "PrimarySubtype";
const ATTR_DISPLAYED_VALUE = "displayedValue";
const GENERATED_DOCUMENT_TYPE_EXCEL = "DGaaSGeneratedDocumentType:Excel";
const GENERATED_DOCUMENT_TYPE_DOC = "DGaaSGeneratedDocumentType:Word";


const DGaaSSelectTemplate = declare(Widget, {

	/**
	 * @override
	 * Query for DGaaSTemplate and DGaaSTemplateRevisions
	 */
	onViewStart(dfds: dojo.store.api.QueryResults<C8Node>[]): void {
		const { cacheView } = this;
		const store = new Nodes({
			cachingStore: cacheView,
			typeNode: "DGaaSTemplate",
			requestParameters: {
				[DEP_PATH]: "Child:CurrentRevision;LatestRevision",
			},
		});
		dfds.push(store.query());
		this.inherited(arguments);
	},

	/**
	 * @override
	 * add default value for OutputType field
	 */
	_resolveView() {
		this.addDefaultValue(FIELD_OUTPUT_TYPE, GENERATED_DOCUMENT_TYPE_DOC);
		this.inherited(arguments);
	},

	/**
	 * @override
	 * Don't add empty entry
	 */
	getFieldStore(field, value) {
		if (field.m_name == FIELD_OUTPUT_TYPE) {
			return enums.getStore("DGaaSGeneratedDocumentType", value, null, true);
		}
		return this.inherited(arguments);
	},

	/**
	 * Initializes the document name based on the selected template and parent container.
	 */
	_onChangeDocumentTemplate(defView, field, value) {
		const docTemplateField = this.getField(FIELD_DOCUMENT_TEMPLATE);
		const docNameField = this.getField(xml.ATTR_NAME);
		const docContainerNode = this.defView.getSource().getParent();
		const parent = this.cacheView.get(docContainerNode[ATTR_PARENT]);

		// Verify whether the document name field is set to a default value or left empty, then generate the name
		if (docNameField.isDefaultValue() || !docNameField.getValue()) {
			var templateValue = docTemplateField.m_control[ATTR_DISPLAYED_VALUE];
			var documentName = "";
			if (templateValue != null && templateValue != "") {
				documentName = parent.$Name + "-" + templateValue;
			}
			this.setFieldValue(docNameField, documentName);
		}
		// Check if the selected template is for Excel extension
		const dGaaSTemplate = this.cacheView.get(value);
		if (dGaaSTemplate) {
			const dGaaSTemplateRevision = this.getCache().get(dGaaSTemplate.LatestRevision);

			const fileId = dGaaSTemplateRevision.Id;
			const outputTypeField = this.getField(FIELD_OUTPUT_TYPE);

			// Set default value for output type and enable the field
			this.setFieldValue(FIELD_OUTPUT_TYPE, GENERATED_DOCUMENT_TYPE_DOC);
			this.setFieldDisabled(outputTypeField, false);

			// Update value and disable the field if the template is an Excel document
			if (fileId.endsWith(EXCEL_FILE_EXTENSION)) {
				this.setFieldValue(FIELD_OUTPUT_TYPE, GENERATED_DOCUMENT_TYPE_EXCEL);
				this.setFieldDisabled(outputTypeField, true);
			}
		}
	},
	/**
	 * @override relationship for template dropdown
	 * Adds query filters to retrieve Active and Approved DGaaSTemplates.
	 * The Primary type on DGaaSTemplates should match the parent node type,
	 * the PrimarySubtype on DGaaSTemplates should match the parent node's Subtype or be a dummy.
	 */
	_getFieldRelationship: function (f, urlNode) {
		if (f.getControlName() == FIELD_DOCUMENT_TEMPLATE) {
			const docContainerNode = this.cacheView.get(urlNode);
			const parentNode = this.cacheView.get(docContainerNode[ATTR_PARENT]);
			const isProductType = ["Style", "Material"].includes(parentNode.$Type);
			const subtypeUrl = isProductType ? parentNode.ProductType : parentNode.Subtype;
			const query = new Query();

			query.And()
				.Attr("Active", xml.OP_EQUALS, true)
				.Attr("PrimaryType", xml.OP_EQUALS, parentNode.$Type)
				.Attr("State", xml.OP_EQUALS, "Revision.State:APPROVED", "Child:CurrentRevision");

			if (!xml.isEmptyURL(subtypeUrl)) {
				const queryOr = query.Or();
				queryOr
					.RefAttr(ATTR_PRIMARY_SUBTYPE, xml.OP_EQUALS, subtypeUrl)
					.RefAttr(ATTR_PRIMARY_SUBTYPE, xml.OP_EQUALS, DUMMY);
			} else {
				query.And()
					.RefAttr(ATTR_PRIMARY_SUBTYPE, xml.OP_EQUALS, DUMMY);
			}
			return Object.assign(new Relationship(), {
				m_typeNode: "DGaaSTemplate",
				m_query: query,
			});
		}
		return this.inherited(arguments);
	},
});
export default DGaaSSelectTemplate;

